import { render, staticRenderFns } from "./v-form-item.vue?vue&type=template&id=74e96ebb"
import script from "./v-form-item.vue?vue&type=script&lang=js"
export * from "./v-form-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e96ebb')) {
      api.createRecord('74e96ebb', component.options)
    } else {
      api.reload('74e96ebb', component.options)
    }
    module.hot.accept("./v-form-item.vue?vue&type=template&id=74e96ebb", function () {
      api.rerender('74e96ebb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/form/v-form-item.vue"
export default component.exports